function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Advocate = "images/hippo-icon-advocate.svg";
var Alarm = "images/hippo-icon-alarm.svg";
var Belongings = "images/hippo-icon-belongings.svg";
var BlinkingHome = "images/hippo-icon-blinking-home.svg";
var Breakup = "images/hippo-icon-breakup.svg";
var BrokenLaptop = "images/hippo-icon-broken-laptop.svg";
var BuildingRed = "images/hippo-icon-building-red.svg";
var Burglar = "images/hippo-icon-burglar.svg";
var Burner = "images/hippo-icon-burner.svg";
var Cake = "images/hippo-icon-cake.svg";
var CalendarBlueMay = "images/hippo-icon-calendar-blue-may.svg";
var CalendarAlt = "images/hippo-icon-calendar-alt.svg";
var CalendarSevenDays = "images/hippo-icon-calendar-seven-days.svg";
var CallUs = "images/hippo-icon-call-us.svg";
var ChatBubble = "images/hippo-icon-chat-bubble.svg";
var Chat = "images/hippo-icon-chat.svg";
var ChildCare = "images/hippo-icon-child-care.svg";
var Clock = "images/hippo-icon-clock.svg";
var Close = "images/hippo-icon-close.svg";
var CloseCircle = "images/hippo-icon-close-circle.svg";
var CloseCircleWhite = "images/hippo-icon-close-circle-white.svg";
var Cloud = "images/hippo-icon-cloud.svg";
var CompanionInv = "images/hippo-icon-companion-inv.svg";
var Companion = "images/hippo-icon-companion.svg";
var Compass = "images/hippo-icon-compass.svg";
var Construction = "images/hippo-icon-construction.svg";
var DeleteIcon = "images/hippo-icon-delete.svg";
var DeleteBlack = "images/hippo-icon-delete-black.svg";
var Documents = "images/hippo-icon-documents.svg";
var DocumentsInv = "images/hippo-icon-documents-inv.svg";
var DocumentLegal = "images/hippo-icon-document-legal.svg";
var Download = "images/hippo-icon-download.svg";
var DeviceSimplisafe = "images/hippo-icon-device-simplisafe.svg";
var EarlyBirdInv = "images/hippo-icon-early-bird-inv.svg";
var EarlyBird = "images/hippo-icon-early-bird.svg";
var EarthquakeInv = "images/hippo-icon-earthquake-inv.svg";
var Earthquake = "images/hippo-icon-earthquake.svg";
var Edit = "images/hippo-icon-edit.svg";
var EnhancedCoverage = "images/hippo-icon-enhanced-coverage.svg";
var EnsureComfortSafety = "images/hippo-icon-couch.svg";
var EquipmentBreakdown = "images/hippo-icon-equipment-breakdown.svg";
var ExtinguisherInv = "images/hippo-icon-extinguisher-inv.svg";
var Extinguisher = "images/hippo-icon-extinguisher.svg";
var Faucet = "images/hippo-icon-faucet.svg";
var FamilyUnit = "images/hippo-icon-family-unit.svg";
var Fence = "images/hippo-icon-fence.svg";
var Fire = "images/hippo-icon-fire.svg";
var Flood = "images/hippo-icon-flood.svg";
var FortifiedHouse = "images/hippo-icon-fortified-house.svg";
var Foundation = "images/hippo-icon-foundation.svg";
var FrPool = "images/hippo-icon-fr-pool.svg";
var GatedInv = "images/hippo-icon-gated-inv.svg";
var Gated = "images/hippo-icon-gated.svg";
var Ghost = "images/hippo-icon-ghost.svg";
var HailResistantRoofInv = "images/hippo-icon-hail-resistant-roof-inv.svg";
var HailResistantRoof = "images/hippo-icon-hail-resistant-roof.svg";
var Hail = "images/hippo-icon-hail.svg";
var HailSad = "images/hippo-icon-hail-sad.svg";
var HippotextGreen = "images/hippo-icon-hippotext-green.svg";
var HippotextWhite = "images/hippo-icon-hippotext-white.svg";
var HoaInv = "images/hippo-icon-hoa-inv.svg";
var Hoa = "images/hippo-icon-hoa.svg";
var HomeCheckupInv = "images/hippo-icon-home-checkup-inv.svg";
var HomeCheckup = "images/hippo-icon-home-checkup.svg";
var HomeOffice = "images/hippo-icon-home-office.svg";
var HouseError = "images/hippo-icon-house-error.svg";
var HouseHappy = "images/hippo-icon-house-happy.svg";
var HouseInspection = "images/hippo-icon-house-inspection.svg";
var HouseLuxury = "images/hippo-icon-house-luxury.svg";
var HousePremium = "images/hippo-icon-house-premium.svg";
var HouseStandard = "images/hippo-icon-house-standard.svg";
var HouseWithBandaid = "images/hippo-icon-house-with-bandaid.svg";
var HouseWithDocument = "images/hippo-icon-house-with-document.svg";
var House = "images/hippo-icon-house.svg";
var Ice = "images/hippo-icon-ice.svg";
var InfoBlack = "images/hippo-icon-info-black.svg";
var KeyChain = "images/hippo-icon-key-chain.svg";
var LaptopAlt = "images/hippo-icon-laptop-alt.svg";
var Liability = "images/hippo-icon-liability.svg";
var Lightning = "images/hippo-icon-lightning.svg";
var Llc = "images/hippo-icon-llc.svg";
var LocalAlarm = "images/hippo-icon-local-alarm.svg";
var LogoGreen = "images/hippo-icon-logo-green.svg";
var LogoWhite = "images/hippo-icon-logo-white.svg";
var MenuHamburgerGreen = "images/hippo-icon-menu-hamburger-green.svg";
var MenuHamburgerWhite = "images/hippo-icon-menu-hamburger-white.svg";
var Miner = "images/hippo-icon-miner.svg";
var Money = "images/hippo-icon-money.svg";
var More = "images/hippo-icon-more.svg";
var MortgageInv = "images/hippo-icon-mortgage-inv.svg";
var Mortgage = "images/hippo-icon-mortgage.svg";
var MortgageMultiple = "images/hippo-icon-mortgage-multiple.svg";
var Nanny = "images/hippo-icon-nanny.svg";
var Other = "images/hippo-icon-other.svg";
var Outlet = "images/hippo-icon-outlet.svg";
var PaperAirplane = "images/hippo-icon-paper-airplane.svg";
var PhoneGreen = "images/hippo-icon-phone-green.svg";
var PhoneWhite = "images/hippo-icon-phone-white.svg";
var Phone = "images/hippo-icon-phone.svg";
var PresentInv = "images/hippo-icon-present-inv.svg";
var Present = "images/hippo-icon-present.svg";
var Proactive = "images/hippo-icon-proactive.svg";
var Ring = "images/hippo-icon-ring.svg";
var RoofLeak = "images/hippo-icon-roof-leak.svg";
var RoofWind1 = "images/hippo-icon-roof-wind-1.svg";
var RoofWind2 = "images/hippo-icon-roof-wind-2.svg";
var RoofWind3 = "images/hippo-icon-roof-wind-3.svg";
var SecondHome = "images/hippo-icon-second-home.svg";
var SensorInv = "images/hippo-icon-sensor-inv.svg";
var Sensor = "images/hippo-icon-sensor.svg";
var ServiceLine = "images/hippo-icon-service-line.svg";
var ShuttersInv = "images/hippo-icon-shutters-inv.svg";
var Shutters = "images/hippo-icon-shutters.svg";
var Simplicity = "images/hippo-icon-simplicity.svg";
var Sinkhole = "images/hippo-icon-sinkhole.svg";
var SmartCoverage = "images/hippo-icon-smart-coverage.svg";
var SmartHomeDevices = "images/hippo-icon-smart-home-devices.svg";
var SmartHomeInv = "images/hippo-icon-smart-home-inv.svg";
var SmartHome = "images/hippo-icon-smart-home.svg";
var Smoke = "images/hippo-icon-smoke.svg";
var SprinklerInv = "images/hippo-icon-sprinkler-inv.svg";
var Sprinkler = "images/hippo-icon-sprinkler.svg";
var StarMedal = "images/hippo-icon-star-medal.svg";
var StiltsHouse = "images/hippo-icon-stilts-house.svg";
var StorageTank = "images/hippo-icon-storage-tank.svg";
var SuitcaseP = "images/hippo-icon-suitcase-p.svg";
var Suitcase = "images/hippo-icon-suitcase.svg";
var Telescope = "images/hippo-icon-telescope.svg";
var Theft = "images/hippo-icon-theft.svg";
var TopNotchCustomerService = "images/hippo-icon-diamond.svg";
var Trust = "images/hippo-icon-trust.svg";
var Vault = "images/hippo-icon-vault.svg";
var WaterBackup = "images/hippo-icon-water-backup.svg";
var WaterBackup2 = "images/hippo-icon-water-backup2.svg";
var Water = "images/hippo-icon-water.svg";
var WelcomeInv = "images/hippo-icon-welcome-inv.svg";
var Welcome = "images/hippo-icon-welcome.svg";
var WindInv = "images/hippo-icon-wind-inv.svg";
var WindStormInv = "images/hippo-icon-wind-storm-inv.svg";
var WindStorm = "images/hippo-icon-wind-storm.svg";
var WindStormSad = "images/hippo-icon-wind-storm-sad.svg";
var Wind = "images/hippo-icon-wind.svg";
var WorkersComp = "images/hippo-icon-workers-comp.svg";
var Up = "images/hippo-icon-up.svg";
var Down = "images/hippo-icon-down.svg";
var BackWhite = "images/hippo-icon-back-white.svg";
var StarOff = "images/hippo-icon-star-off.svg";
var Plus = "images/hippo-icon-plus.svg";
var PartnerPlus = "images/simplisafe-plus.svg";
var Minus = "images/hippo-icon-minus.svg";
var WrongInput = "images/hippo-icon-wrong-input.svg";
var Checkbox = "images/checkbox.svg";
var Dogs = "images/hippo-icon-dog.svg";
var ExoticPet = "images/hippo-icon-exotic-pet.svg";
var Trampoline = "images/hippo-icon-trampoline.svg";
var Facebook = "images/hippo-icon-facebook.svg";
var Forbes = "images/hippo-icon-forbes.svg";
var Fortune = "images/hippo-icon-fortune.svg";
var LinkedIn = "images/hippo-icon-linkedin.svg";
var Twitter = "images/hippo-icon-twitter.svg";
var UsaToday = "images/hippo-icon-usa-today.svg";
var Wsj = "images/hippo-icon-wsj.svg";
var Zillow = "images/hippo-icon-zillow.svg";
var Munichre = "images/hippo-icon-munichre.svg";
var Spinnaker = "images/hippo-icon-spinnaker.svg";
var Topa = "images/hippo-icon-topa.svg";
var Communities = "images/hippo-icon-communities.svg";
var Leads = "images/hippo-icon-leads.svg";
var UploadCommunities = "images/hippo-icon-upload-communities.svg";
var UploadLeads = "images/hippo-icon-upload-leads.svg";
var Castle = "images/castle.svg";
var Roof = "images/roof.svg";
var Ruler = "images/ruler.svg";
var BrickVeneer = "images/brick_veneer.svg";
var CinderBlock = "images/cinder_block.svg";
var Masonry = "images/masonry.svg";
var Steel = "images/steel.svg";
var WoodFrame = "images/wood_frame.svg";
var Architectural = "images/architectural.svg";
var Asphalt = "images/asphalt.svg";
var Clay = "images/clay.svg";
var Concrete = "images/concrete.svg";
var Flat = "images/flat.svg";
var OtherRoof = "images/other-roof.svg";
var Slate = "images/slate.svg";
var Wood = "images/wood.svg";
var SadHouse = "images/hippo-icon-sad-house.svg";
var Returning = "images/hippo-icon-returning.svg";
var ReturningInv = "images/hippo-icon-returning-inv.svg";
var Xfinity = "images/hippo-icon-xfinity.svg";
var Simplisafe = "images/hippo-icon-simplisafe.svg";
var LogIn = "images/hippo-icon-log-in.svg";
var QuestionMarkCircle = "images/hippo-icon-question-mark-circle.svg";
var HippoHomeCare = "images/hippo-icon-home-care.svg";
var CancelExistingPolicy = "images/hippo-icon-cancel-existing-policy.svg";
var CancelExistingPolicyInv = "images/hippo-icon-cancel-existing-policy-inv.svg";
var Handyman = "images/hippo-icon-handyman.svg";
var Adt = "images/hippo-icon-adt.svg"; // Neutral icons

var NeutralAdvocate = "images/hippo-icon-neutral-advocate.svg";
var NeutralAlarm = "images/hippo-icon-neutral-alarm.svg";
var NeutralArchitectural = "images/hippo-icon-neutral-architectural.svg";
var NeutralAsphalt = "images/hippo-icon-neutral-asphalt.svg";
var NeutralCompanionInv = "images/hippo-icon-neutral-auto-inv.svg";
var NeutralCompanion = "images/hippo-icon-neutral-auto.svg";
var NeutralBelongings = "images/hippo-icon-neutral-belongings.svg";
var NeutralBlinkingHome = "images/hippo-icon-neutral-blinking-home.svg";
var NeutralBreakup = "images/hippo-icon-neutral-breakup.svg";
var NeutralBrickVeneer = "images/hippo-icon-neutral-brick-veneer.svg";
var NeutralBrokenLaptop = "images/hippo-icon-neutral-broken-laptop.svg";
var NeutralBuildingRed = "images/hippo-icon-neutral-building-red.svg";
var NeutralBurglar = "images/hippo-icon-neutral-burglar.svg";
var NeutralBurner = "images/hippo-icon-neutral-burner.svg";
var NeutralCake = "images/hippo-icon-neutral-cake.svg";
var NeutralCalendarBlueMay = "images/hippo-icon-neutral-calendar-blue-may.svg";
var NeutralCalendarAlt = "images/hippo-icon-neutral-calender-alt.svg";
var NeutralCallUs = "images/hippo-icon-neutral-call-us.svg";
var NeutralCancelExistingPolicyInv = "images/hippo-icon-neutral-cancel-existing-policy-inv.svg";
var NeutralCancelExistingPolicy = "images/hippo-icon-neutral-cancel-existing-policy.svg";
var NeutralCastle = "images/hippo-icon-neutral-castle.svg";
var NeutralChat = "images/hippo-icon-neutral-chat.svg";
var NeutralChildCare = "images/hippo-icon-neutral-child-care.svg";
var NeutralCinderBlock = "images/hippo-icon-neutral-cinder-block.svg";
var NeutralClay = "images/hippo-icon-neutral-clay.svg";
var NeutralClock = "images/hippo-icon-neutral-clock.svg";
var NeutralCloud = "images/hippo-icon-neutral-cloud.svg";
var NeutralCompass = "images/hippo-icon-neutral-compass.svg";
var NeutralConcrete1 = "images/hippo-icon-neutral-concrete-1.svg";
var NeutralConcrete = "images/hippo-icon-neutral-concrete.svg";
var NeutralConstruction = "images/hippo-icon-neutral-construction.svg";
var NeutralEnsureComfortSafety = "images/hippo-icon-neutral-couch.svg";
var NeutralTopNotchCustomerService = "images/hippo-icon-neutral-diamond.svg";
var NeutralDocumentLegal = "images/hippo-icon-neutral-document-legal.svg";
var NeutralDocumentsInv = "images/hippo-icon-neutral-documents-inv.svg";
var NeutralDocuments = "images/hippo-icon-neutral-documents.svg";
var NeutralDogs = "images/hippo-icon-neutral-dog.svg";
var NeutralDeviceSimplisafe = "images/hippo-icon-neutral-device-simplisafe.svg";
var NeutralDownload = "images/hippo-icon-neutral-download.svg";
var NeutralEarlyBirdInv = "images/hippo-icon-neutral-early-bird-inv.svg";
var NeutralEarlyBird = "images/hippo-icon-neutral-early-bird.svg";
var NeutralEarthquakeInv = "images/hippo-icon-neutral-earthquake-inv.svg";
var NeutralEarthquake = "images/hippo-icon-neutral-earthquake.svg";
var NeutralEdit = "images/hippo-icon-neutral-edit.svg";
var NeutralEnhancedCoverage = "images/hippo-icon-neutral-enhanced-coverage.svg";
var NeutralEquipmentBreakdown = "images/hippo-icon-neutral-equipment-breakdown.svg";
var NeutralExoticPet = "images/hippo-icon-neutral-exotic-pet.svg";
var NeutralExtinguisherInv = "images/hippo-icon-neutral-extinguisher-inv.svg";
var NeutralExtinguisher = "images/hippo-icon-neutral-extinguisher.svg";
var NeutralFamilyUnit = "images/hippo-icon-neutral-family-unit.svg";
var NeutralFaucet = "images/hippo-icon-neutral-faucet.svg";
var NeutralFence = "images/hippo-icon-neutral-fence.svg";
var NeutralFire = "images/hippo-icon-neutral-fire.svg";
var NeutralFlat = "images/hippo-icon-neutral-flat.svg";
var NeutralFlood = "images/hippo-icon-neutral-flood.svg";
var NeutralFortifiedHouse = "images/hippo-icon-neutral-fortified-house.svg";
var NeutralFoundation = "images/hippo-icon-neutral-foundation.svg";
var NeutralFrPool = "images/hippo-icon-neutral-fr-pool.svg";
var NeutralWoodFrame = "images/hippo-icon-neutral-frame.svg";
var NeutralGatedInv = "images/hippo-icon-neutral-gated-inv.svg";
var NeutralGated = "images/hippo-icon-neutral-gated.svg";
var NeutralGhost = "images/hippo-icon-neutral-ghost.svg";
var NeutralGlassResistant = "images/hippo-icon-neutral-glass-resistant.svg";
var NeutralGolfCartInv = "images/hippo-icon-neutral-golf-cart-inv.svg";
var NeutralGolfCart = "images/hippo-icon-neutral-golf-cart.svg";
var NeutralHailResistantRoofInv = "images/hippo-icon-neutral-hail-resistant-roof-inv.svg";
var NeutralHailResistantRoof = "images/hippo-icon-neutral-hail-resistant-roof.svg";
var NeutralMenuHamburgerGreen = "images/hippo-icon-neutral-menu-hamburger.svg";
var NeutralHandyman = "images/hippo-icon-neutral-hippo-pro.svg";
var NeutralHoaInv = "images/hippo-icon-neutral-hoa-inv.svg";
var NeutralHoa = "images/hippo-icon-neutral-hoa.svg";
var NeutralHomeCheckupInv = "images/hippo-icon-neutral-home-checkup-inv.svg";
var NeutralHomeCheckup = "images/hippo-icon-neutral-home-checkup.svg";
var NeutralHomeOffice = "images/hippo-icon-neutral-home-office.svg";
var NeutralHouseError = "images/hippo-icon-neutral-house-error.svg";
var NeutralHouseHappy = "images/hippo-icon-neutral-house-happy.svg";
var NeutralHouseInspection = "images/hippo-icon-neutral-house-inspection.svg";
var NeutralHouseLuxury = "images/hippo-icon-neutral-house-luxury.svg";
var NeutralHouse = "images/hippo-icon-neutral-house.svg";
var NeutralHousePremium = "images/hippo-icon-neutral-house-premium.svg";
var NeutralHouseStandard = "images/hippo-icon-neutral-house-standard.svg";
var NeutralHouseWithBandaid = "images/hippo-icon-neutral-house-with-bandaid.svg";
var NeutralHouseWithDocument = "images/hippo-icon-neutral-house-with-document.svg";
var NeutralIce = "images/hippo-icon-neutral-ice.svg";
var NeutralKeyChain = "images/hippo-icon-neutral-key-chain.svg";
var NeutralLaptopAlt = "images/hippo-icon-neutral-laptop.svg";
var NeutralLeads = "images/hippo-icon-neutral-leads.svg";
var NeutralLiability = "images/hippo-icon-neutral-liability.svg";
var NeutralLlc = "images/hippo-icon-neutral-llc.svg";
var NeutralLocalAlarm = "images/hippo-icon-neutral-local-alarm.svg";
var NeutralMasonry = "images/hippo-icon-neutral-masonry.svg";
var NeutralMiner = "images/hippo-icon-neutral-miner.svg";
var NeutralCommunities = "images/hippo-icon-neutral-mixed-community.svg";
var NeutralMoney = "images/hippo-icon-neutral-money.svg";
var NeutralMore = "images/hippo-icon-neutral-more.svg";
var NeutralMortgageInv = "images/hippo-icon-neutral-mortgage-inv.svg";
var NeutralMortgage = "images/hippo-icon-neutral-mortgage.svg";
var NeutralMortgageMultiple = "images/hippo-icon-neutral-mortgage-multiple.svg";
var NeutralNanny = "images/hippo-icon-neutral-nany.svg";
var NeutralOther = "images/hippo-icon-neutral-other.svg";
var NeutralOtherRoof = "images/hippo-icon-neutral-other-roof.svg";
var NeutralOutlet = "images/hippo-icon-neutral-outlet.svg";
var NeutralPaperAirplane = "images/hippo-icon-neutral-paper-airplane.svg";
var NeutralPhone = "images/hippo-icon-neutral-phone.svg";
var NeutralPresentInv = "images/hippo-icon-neutral-present-inv.svg";
var NeutralPresent = "images/hippo-icon-neutral-present.svg";
var NeutralProactive = "images/hippo-icon-neutral-proactive.svg";
var NeutralRing = "images/hippo-icon-neutral-ring.svg";
var NeutralRoofWind1 = "images/hippo-icon-neutral-roof-1.svg";
var NeutralRoofWind2 = "images/hippo-icon-neutral-roof-2.svg";
var NeutralRoofWind3 = "images/hippo-icon-neutral-roof-3.svg";
var NeutralRoof = "images/hippo-icon-neutral-roofs.svg";
var NeutralRuler = "images/hippo-icon-neutral-ruler.svg";
var NeutralSadHouse = "images/hippo-icon-neutral-sad-house.svg";
var NeutralSecondHome = "images/hippo-icon-neutral-second-home.svg";
var NeutralSeniorInv = "images/hippo-icon-neutral-senior-inv.svg";
var NeutralSenior = "images/hippo-icon-neutral-senior.svg";
var NeutralSensorInv = "images/hippo-icon-neutral-sensor-inv.svg";
var NeutralSensor = "images/hippo-icon-neutral-sensor.svg";
var NeutralServiceLine = "images/hippo-icon-neutral-service-line.svg";
var NeutralShield = "images/hippo-icon-neutral-shield.svg";
var NeutralShuttersInv = "images/hippo-icon-neutral-shutters-inv.svg";
var NeutralShutters = "images/hippo-icon-neutral-shutters.svg";
var NeutralSinkhole = "images/hippo-icon-neutral-sinkhole.svg";
var NeutralSlate = "images/hippo-icon-neutral-slate.svg";
var NeutralSmartCoverage = "images/hippo-icon-neutral-smart-coverage.svg";
var NeutralSmartHomeDevices = "images/hippo-icon-neutral-smart-home-devices.svg";
var NeutralSmartHomeInv = "images/hippo-icon-neutral-smart-home-inv.svg";
var NeutralSmartHome = "images/hippo-icon-neutral-smart-home.svg";
var NeutralSmoke = "images/hippo-icon-neutral-smoke.svg";
var NeutralSprinklerInv = "images/hippo-icon-neutral-sprinkler-inv.svg";
var NeutralSprinkler = "images/hippo-icon-neutral-sprinkler.svg";
var NeutralStarMedal = "images/hippo-icon-neutral-star-medal.svg";
var NeutralSteel1 = "images/hippo-icon-neutral-steel-1.svg";
var NeutralSteel = "images/hippo-icon-neutral-steel.svg";
var NeutralStiltsHouse = "images/hippo-icon-neutral-stilts-house.svg";
var NeutralStorageTank = "images/hippo-icon-neutral-storage-tank.svg";
var NeutralSuitcase = "images/hippo-icon-neutral-suitcase.svg";
var NeutralSuitcaseP = "images/hippo-icon-neutral-suitcase-p.svg";
var NeutralSuitcaseTag = "images/hippo-icon-neutral-suitcase-tag.svg";
var NeutralTajmahal = "images/hippo-icon-neutral-tajmahal.svg";
var NeutralTelescope = "images/hippo-icon-neutral-telescope.svg";
var NeutralTheft = "images/hippo-icon-neutral-theft.svg";
var NeutralTrampoline = "images/hippo-icon-neutral-trampoline.svg";
var NeutralTrust = "images/hippo-icon-neutral-trust.svg";
var NeutralUploadCommunities = "images/hippo-icon-neutral-upload-communities.svg";
var NeutralUploadLeads = "images/hippo-icon-neutral-upload-leads.svg";
var NeutralVault = "images/hippo-icon-neutral-vault.svg";
var NeutralWaterBackup = "images/hippo-icon-neutral-water-backup.svg";
var NeutralWaterBackup2 = "images/hippo-icon-neutral-water-backup2.svg";
var NeutralWater = "images/hippo-icon-neutral-water.svg";
var NeutralWelcomeInv = "images/hippo-icon-neutral-welcome-inv.svg";
var NeutralWelcome = "images/hippo-icon-neutral-welcome.svg";
var NeutralWindInv = "images/hippo-icon-neutral-wind-inv.svg";
var NeutralWind = "images/hippo-icon-neutral-wind.svg";
var NeutralWindStormInv = "images/hippo-icon-neutral-wind-storm-inv.svg";
var NeutralWindStorm = "images/hippo-icon-neutral-wind-storm.svg";
var NeutralWood = "images/hippo-icon-neutral-wood.svg";
var NeutralWorkersComp = "images/hippo-icon-neutral-workers-comp.svg";
var Exclamation = "images/exclamation-icon.svg";
var WarningTriangle = "images/warning-triangle.svg"; // Inline svg icons

import { ArrowDown, ArrowUp, Back, BackButton, Checked, CheckMark, Forward, Info, StarOn } from '../svg-inline-icons';
export var inlineSVGIcons = {
  ArrowDown,
  ArrowUp,
  Back,
  BackButton,
  Checked,
  CheckMark,
  Forward,
  Info,
  StarOn
};
export var svgIcons = {
  Advocate,
  Adt,
  Alarm,
  Belongings,
  BlinkingHome,
  Breakup,
  BrokenLaptop,
  BuildingRed,
  Burglar,
  Burner,
  Cake,
  CalendarBlueMay,
  CalendarAlt,
  CalendarSevenDays,
  CallUs,
  ChatBubble,
  Chat,
  Checkbox,
  ChildCare,
  Clock,
  Close,
  CloseCircle,
  CloseCircleWhite,
  Cloud,
  CompanionInv,
  Companion,
  Compass,
  Construction,
  Delete: DeleteIcon,
  Documents,
  DocumentsInv,
  DocumentLegal,
  Download,
  DeviceSimplisafe,
  EarlyBirdInv,
  EarlyBird,
  EarthquakeInv,
  Earthquake,
  Edit,
  EnhancedCoverage,
  EnsureComfortSafety,
  EquipmentBreakdown,
  Exclamation,
  ExtinguisherInv,
  Extinguisher,
  Faucet,
  FamilyUnit,
  Fence,
  Fire,
  Flood,
  FortifiedHouse,
  Foundation,
  FrPool,
  GatedInv,
  Gated,
  Ghost,
  HailResistantRoofInv,
  HailResistantRoof,
  Hail,
  HailSad,
  HippotextGreen,
  HippotextWhite,
  HoaInv,
  Hoa,
  HomeCheckupInv,
  HomeCheckup,
  HouseInspection,
  HomeOffice,
  HouseError,
  HouseHappy,
  HouseLuxury,
  HousePremium,
  HouseStandard,
  HouseWithBandaid,
  HouseWithDocument,
  House,
  Ice,
  InfoBlack,
  KeyChain,
  LaptopAlt,
  Liability,
  Lightning,
  Llc,
  LocalAlarm,
  LogoGreen,
  LogoWhite,
  MenuHamburgerGreen,
  MenuHamburgerWhite,
  Miner,
  Money,
  More,
  MortgageInv,
  Mortgage,
  MortgageMultiple,
  Nanny,
  Other,
  Outlet,
  PaperAirplane,
  PhoneGreen,
  PhoneWhite,
  Phone,
  PresentInv,
  Present,
  Proactive,
  Ring,
  SecondHome,
  SensorInv,
  Sensor,
  ServiceLine,
  ShuttersInv,
  Shutters,
  Simplicity,
  Sinkhole,
  SmartCoverage,
  SmartHomeDevices,
  SmartHomeInv,
  SmartHome,
  Smoke,
  SprinklerInv,
  Sprinkler,
  StarMedal,
  StiltsHouse,
  StorageTank,
  SuitcaseP,
  Suitcase,
  Telescope,
  Theft,
  TopNotchCustomerService,
  Trust,
  Vault,
  WaterBackup,
  WaterBackup2,
  Water,
  WelcomeInv,
  Welcome,
  WindInv,
  WindStormInv,
  WindStorm,
  WindStormSad,
  Wind,
  WorkersComp,
  Up,
  Down,
  BackWhite,
  StarOff,
  DeleteBlack,
  Plus,
  PartnerPlus,
  Minus,
  WrongInput,
  Trampoline,
  Dogs,
  ExoticPet,
  Facebook,
  Forbes,
  Fortune,
  LinkedIn,
  Twitter,
  UsaToday,
  Wsj,
  Zillow,
  Munichre,
  Spinnaker,
  Topa,
  Communities,
  Leads,
  UploadCommunities,
  UploadLeads,
  Castle,
  Roof,
  RoofLeak,
  RoofWind1,
  RoofWind2,
  RoofWind3,
  Ruler,
  BrickVeneer,
  CinderBlock,
  Masonry,
  Steel,
  WoodFrame,
  Architectural,
  Asphalt,
  Clay,
  Concrete,
  Flat,
  OtherRoof,
  Slate,
  Wood,
  SadHouse,
  Returning,
  ReturningInv,
  Xfinity,
  Simplisafe,
  LogIn,
  QuestionMarkCircle,
  HippoHomeCare,
  CancelExistingPolicy,
  CancelExistingPolicyInv,
  Handyman,
  NeutralAdvocate,
  NeutralAlarm,
  NeutralArchitectural,
  NeutralAsphalt,
  NeutralCompanionInv,
  NeutralCompanion,
  NeutralBelongings,
  NeutralBlinkingHome,
  NeutralBreakup,
  NeutralBrickVeneer,
  NeutralBrokenLaptop,
  NeutralBuildingRed,
  NeutralBurglar,
  NeutralBurner,
  NeutralCake,
  NeutralCalendarBlueMay,
  NeutralCalendarAlt,
  NeutralCallUs,
  NeutralCancelExistingPolicyInv,
  NeutralCancelExistingPolicy,
  NeutralCastle,
  NeutralChat,
  NeutralChildCare,
  NeutralCinderBlock,
  NeutralClay,
  NeutralClock,
  NeutralCloud,
  NeutralCompass,
  NeutralConcrete1,
  NeutralConcrete,
  NeutralConstruction,
  NeutralEnsureComfortSafety,
  NeutralTopNotchCustomerService,
  NeutralDocumentLegal,
  NeutralDocumentsInv,
  NeutralDocuments,
  NeutralDogs,
  NeutralDownload,
  NeutralDeviceSimplisafe,
  NeutralEarlyBirdInv,
  NeutralEarlyBird,
  NeutralEarthquakeInv,
  NeutralEarthquake,
  NeutralEdit,
  NeutralEnhancedCoverage,
  NeutralEquipmentBreakdown,
  NeutralExoticPet,
  NeutralExtinguisherInv,
  NeutralExtinguisher,
  NeutralFamilyUnit,
  NeutralFaucet,
  NeutralFence,
  NeutralFire,
  NeutralFlat,
  NeutralFlood,
  NeutralFortifiedHouse,
  NeutralFoundation,
  NeutralFrPool,
  NeutralWoodFrame,
  NeutralGatedInv,
  NeutralGated,
  NeutralGhost,
  NeutralGlassResistant,
  NeutralGolfCartInv,
  NeutralGolfCart,
  NeutralHailResistantRoofInv,
  NeutralHailResistantRoof,
  NeutralMenuHamburgerGreen,
  NeutralHandyman,
  NeutralHoaInv,
  NeutralHoa,
  NeutralHomeCheckupInv,
  NeutralHomeCheckup,
  NeutralHouseInspection,
  NeutralHomeOffice,
  NeutralHouseError,
  NeutralHouseHappy,
  NeutralHouseLuxury,
  NeutralHouse,
  NeutralHousePremium,
  NeutralHouseStandard,
  NeutralHouseWithBandaid,
  NeutralHouseWithDocument,
  NeutralIce,
  NeutralKeyChain,
  NeutralLaptopAlt,
  NeutralLeads,
  NeutralLiability,
  NeutralLlc,
  NeutralLocalAlarm,
  NeutralMasonry,
  NeutralMiner,
  NeutralCommunities,
  NeutralMoney,
  NeutralMore,
  NeutralMortgageInv,
  NeutralMortgage,
  NeutralMortgageMultiple,
  NeutralNanny,
  NeutralOther,
  NeutralOtherRoof,
  NeutralOutlet,
  NeutralPaperAirplane,
  NeutralPhone,
  NeutralPresentInv,
  NeutralPresent,
  NeutralProactive,
  NeutralRing,
  NeutralRoofWind1,
  NeutralRoofWind2,
  NeutralRoofWind3,
  NeutralRoof,
  NeutralRuler,
  NeutralSadHouse,
  NeutralSecondHome,
  NeutralSeniorInv,
  NeutralSenior,
  NeutralSensorInv,
  NeutralSensor,
  NeutralServiceLine,
  NeutralShield,
  NeutralShuttersInv,
  NeutralShutters,
  NeutralSinkhole,
  NeutralSlate,
  NeutralSmartCoverage,
  NeutralSmartHomeDevices,
  NeutralSmartHomeInv,
  NeutralSmartHome,
  NeutralSmoke,
  NeutralSprinklerInv,
  NeutralSprinkler,
  NeutralStarMedal,
  NeutralSteel1,
  NeutralSteel,
  NeutralStiltsHouse,
  NeutralStorageTank,
  NeutralSuitcase,
  NeutralSuitcaseP,
  NeutralSuitcaseTag,
  NeutralTajmahal,
  NeutralTelescope,
  NeutralTheft,
  NeutralTrampoline,
  NeutralTrust,
  NeutralUploadCommunities,
  NeutralUploadLeads,
  NeutralVault,
  NeutralWaterBackup,
  NeutralWaterBackup2,
  NeutralWater,
  NeutralWelcomeInv,
  NeutralWelcome,
  NeutralWindInv,
  NeutralWind,
  NeutralWindStormInv,
  NeutralWindStorm,
  NeutralWood,
  NeutralWorkersComp,
  WarningTriangle
};
export default _objectSpread(_objectSpread({}, svgIcons), inlineSVGIcons);